import React from "react";
// react components for routing our app without refresh
import { Link } from "react-router-dom";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
// material-ui core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import LocationOnIcon from "@material-ui/icons/LocationOn";
import EmailIcon from "@material-ui/icons/Email";
import PhoneIcon from "@material-ui/icons/Phone";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import styles from "assets/jss/material-kit-react/components/footerStyle.js";

const useStyles = makeStyles(styles);

export default function Footer(props) {
  const classes = useStyles();
  const { whiteFont } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont,
  });
  return (
    <footer className={footerClasses}>
      <div className={classes.container}>
        <GridContainer justifyContent="center">
          <GridItem sm={12} md={4}>
            <h4 className={classes.title}>ABOUT</h4>
            <p>
              A refreshed version of mini project Lost and Found Management
              System by Rohit Ranbhare.
            </p>
          </GridItem>
          <GridItem sm={12} md={4}>
            <h4 className={classes.title}>LINKS</h4>
            <Link to="/" className={classes.link}>
              Home
            </Link>
            <br />
            <Link to="/lostitems" className={classes.link}>
              Lost Items
            </Link>
            <br />
            <Link to="/founditems" className={classes.link}>
              Found Items
            </Link>
            <br />
            <Link to="/lostitemhistory" className={classes.link}>
              Lost Item History
            </Link>
            <br />
            <Link to="/founditemhistory" className={classes.link}>
              Found Item History
            </Link>
          </GridItem>
          <GridItem sm={12} md={4}>
            <h4 className={classes.title}>CONTACT</h4>
            <p>
              <LocationOnIcon /> Pune, Maharashtra, India.
            </p>
            <p>
              <EmailIcon /> lostandfoundltd@mail.com
            </p>
            <p>
              <PhoneIcon /> +91 1234567890
            </p>
          </GridItem>
        </GridContainer>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  whiteFont: PropTypes.bool,
};
